<script>
import { Bar } from "vue-chartjs";
import { CustomTooltips } from "@coreui/coreui-plugin-chartjs-custom-tooltips";

export default {
  extends: Bar,
  props: {
    barLabel: {
      type: [Array],
      default: () => [],
    },
    barData: {
      type: [Array],
      default: () => [],
    },
  },
  mounted() {
    // Overwriting base render method with actual data.
    this.renderChart(
      {
        labels: this.barLabel,
        datasets: this.barData,
        // datasets: [
        //   {
        //     label: "GitHub Commits",
        //     backgroundColor: "#f87979",
        //     data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
        //   },
        //   {
        //     label: "GitHub Commits2",
        //     backgroundColor: "#f87979",
        //     data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
        //   }
        // ]
      },
      {
        responsive: true,
        maintainAspectRatio: true,
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: "index",
          position: "nearest",
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return {
                backgroundColor:
                  chart.data.datasets[tooltipItem.datasetIndex].backgroundColor,
              };
            },
          },
        },
        onClick: (event, chart) => {
            this.$emit("openVerificationDetail",event);
         
        },
      }
    );
  },
};
</script>
